import { render, staticRenderFns } from "./VideoPlayerControls.vue?vue&type=template&id=4381ba6b&"
import script from "./VideoPlayerControls.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports